import { render, staticRenderFns } from "./FormCheck.vue?vue&type=template&id=4d54c574&scoped=true&"
import script from "./FormCheck.vue?vue&type=script&lang=js&"
export * from "./FormCheck.vue?vue&type=script&lang=js&"
import style0 from "./FormCheck.vue?vue&type=style&index=0&id=4d54c574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d54c574",
  null
  
)

export default component.exports